export default __webpack_public_path__ + "static/media/cm.380a41a9.jpg";